import { repeaterSourceSchemaFacets } from '@plone-collective/volto-repeater-source-facets/schema';

import { getQuerystring, getVocabulary } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';

function applyConfig(config) {
  config.settings['volto-repeater-block'].sources = {
    ...config.settings['volto-repeater-block'].sources,
    facetSource: {
      title: 'Facet source',
      schema: repeaterSourceSchemaFacets,
      fetchFromSource: (sourceSettings, state) => {
        // TODO: Figure out why extensions don't exist during SSR so this works. Can do it manually for now
        const facet = sourceSettings.facet;
        if (!facet) {
          return [];
        }
        // TODO: Verify if/ how this can get changed other than through search
        const facetWidgets =
          config.blocks.blocksConfig.search.extensions.facetWidgets;
        const facetOptions =
          facetWidgets.types.find(
            (facetDefinition) => facetDefinition.id === facet.type,
          ) ||
          facetWidgets.types.find(
            (facetDefinition) => facetDefinition.isDefault,
          );
        const { valueToQuery } = facetOptions;

        const index = state.querystring.indexes[facet?.field?.value];
        let searchPageUrl = sourceSettings?.searchPage?.[0]?.['@id'];
        if (searchPageUrl) {
          searchPageUrl = flattenToAppURL(searchPageUrl);
        }

        // If you choose a facet then try to remove it, the data isn't always returned to null/ undefined.
        if (!index?.values) {
          return [];
        }

        return Object.entries(index.values).map(
          ([indexName, { title: indexTitle }]) => {
            const query = valueToQuery({
              value: facet.multiple ? [indexName] : indexName,
              facet,
            });
            return {
              url: `${searchPageUrl}#query=${encodeURIComponent(
                JSON.stringify([query]),
              )}`,
              title: indexTitle,
            };
          },
        );
      },
    },
  };

  config.settings.asyncPropsExtenders = [
    ...(config.settings.asyncPropsExtenders ?? []),
    {
      // TODO: location-dependent vocabularies
      path: '/',
      extend: (dispatchActions) => {
        return [
          ...dispatchActions,
          {
            key: 'volto-repeater-source-facets-metadata-vocabulary',
            promise: ({ store: { dispatch } }) => {
              if (!__SERVER__) {
                return;
              }
              const action = getVocabulary({
                vocabNameOrURL: 'plone.app.vocabularies.MetadataFields',
                size: -1,
              });
              return dispatch(action).catch((e) => {
                // eslint-disable-next-line
                console.log(
                  'Error getting MetadataFields for repeater-source-facets',
                  e,
                );
              });
            },
          },
          {
            key: 'volto-repeater-source-facets-querystring',
            promise: ({ store: { dispatch } }) => {
              if (!__SERVER__) {
                return;
              }
              const action = getQuerystring();
              return dispatch(action).catch((e) => {
                // eslint-disable-next-line
                console.log('Error getting vocabularies', e);
              });
            },
          },
        ];
      },
    },
  ];

  return config;
}

export default applyConfig;
